import { UseContextApp } from "../Global/Context/appContext";
import { formatDate } from "../helpers/formatDate";
import { getIp } from "../helpers/getIp";
import ServerCall from "./ServerCall";

const PagosController = () => {
  const [{ user }] = UseContextApp();
  const pagoZelle = async (input) => {
      var body = new FormData();
      body.append("Confirmacion", "no-aplica");
      body.append("nroCuenta", input.cuenta);
      body.append("NombrePagador", input.nombre);
      body.append("ApellidoPagador", input.apellido);
      body.append("Monto", input.monto);
      body.append("Email", input.email);
      body.append("Fecha", formatDate(input.fecha));
      const response = await ServerCall.post(
        `/Recaudacion/Zelle`,
        body,
        user.token
      );
      return response;

  };
  const crearPagoBDV = async (input) => {
      var body = new FormData();
      body.append("idTransaccion", input.idTransaccion);
      body.append("idCuenta", input.cuenta);
      body.append("currency", 1);
      body.append("monto", input.monto);
      body.append("canal", "Portal Web");
      body.append("nombreCliente", input.name);
      body.append("idDocIdentificacion", input.selectDoc); 
      body.append("docIdentificacion", input.cedula);
      body.append("telefonoPago", input.telefono);
      body.append("correo", input.correo);
      const response = await ServerCall.post(
        `/Recaudacion/Biopago/CreatePayment`,
        body,
        user.token
      );

      return response;
 };

  const procesarPagoBDV = async (input) => {
      var body = new FormData();
      body.append("idPayment", input.idPago);
      body.append("smsCodeBDV", input.codigoSms);
      body.append("tipoCuenta", input.tipoCuenta);
      const response = await ServerCall.post(
        `/Recaudacion/Biopago/ProcessPayment`,
        body,
        user.token
      );
      return response;

  };

  const notificacionP2C = async (input) => {
      var body = new FormData();
      body.append("idPago", input.idPago);
      body.append("idCuenta", input.idCuenta);
      body.append("currency", 1);
      body.append("monto", input.monto);
      body.append("canal", "Portal Web");
      body.append("referencia", input.referencia);
      body.append("codBanco", input.codigoBanco); 
      body.append("idDocIdentificacion", input.docType); 
      body.append("docIdentificacion", input.cedula);
      body.append("telefonoPago", input.telefonoP);
      body.append("banco", input.banco);
      body.append("fechaPago", formatDate(input.fecha));
      const response = await ServerCall.post(
        `/Recaudacion/Bancamiga/Notificaciones`,
        body,
        user.token
      );
      return response;
  };

  const afilicacionP2C = async (input) => {

      var body = new FormData();
      body.append("docIdentidad", input.docIdentidad);
      const response = await ServerCall.post(
        `/Recaudacion/Bancamiga/AfiliacionP2C`,
        body,
        user.token
      );
      return response;
 };

  const desAfilicacionP2C = async (input) => {
      var body = new FormData();
      body.append("docIdentidad", input.docIdentidad);
      body.append("idBanco", input.idBanco);
      body.append("telefonoOrigen", input.phone.replace("0", "58"));
      const response = await ServerCall.post(
        `/Recaudacion/Bancamiga/DesAfiliacionP2C`,
        body,
        user.token
      );
      return response;
  };

  const getBancos = async (input) => {

      var body = new FormData();
      const response = await ServerCall.post(
        `/Recaudacion/Bancamiga/GetBancos`,
        body,
        user.token
      );
   
      return response;
  };

  const pagoBanesco = async (input) => {
      var body = new FormData();
      body.append("idCuenta", input.idCuenta);
      body.append("monto", input.monto);
      body.append("idPago", input.idPago);
      const response = await ServerCall.post(
        `/Recaudacion/Banesco/CreatePaymentBanesco`,
        body,
        user.token
      );
      return response;
  };

  const tokenCreditCard = async (input) => {
      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("rif", input.rif); 
      const response = await ServerCall.post(
        `/Recaudacion/Credicard/TokenCredicard`,
        body,
        user.token
      );
      return response;
  };

  const pagoCreditCard = async (input) => {
      var body = new FormData();
      body.append("idCuenta", input.cuenta);
      body.append("canal", "Portal Web");
      body.append("transaccion", input.transaccion);
      body.append("ip", await getIp());
      body.append("nombreCliente", input.nombreCliente);
      body.append("monto", input.monto);
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("mesExpiracion", input.mesExp);
      body.append("anioExpiracion", input.anoExp);
      body.append("nombreTitular", input.nombreTitular); 
      body.append("tipoIdentificacion", input.docType); 
      body.append("rif", input.rif); 
      body.append("tipoTarjeta", input.tipoTarjeta); 
      body.append("tipoCuenta", input.tipoCuenta);
      body.append("tlf", input.tlf);
      body.append("pin", input.pin);
      body.append("cvc", input.cvc);
      body.append("token", input.token);

      const response = await ServerCall.post(
        `/Recaudacion/Credicard/CreatePaymentCredicard`,
        body,
        user.token
      );
      return response;
  };

  const getTarjetaMercantil = async (input) => {
      var body = new FormData();
      body.append("docIdentidad", input.docIdentidad);
      body.append("idCliente", input.idCliente);
      const response = await ServerCall.post(
        `/Recaudacion/MercantilPA/GetTarjeta`,
        body,
        user.token
      );
      return response;
  };

  const deleteTarjetaMercantil = async (input) => {
      var body = new FormData();
      body.append("docIdentidad", input.docIdentidad);
      body.append("idCliente", input.idCliente);
      body.append("token", input.token);
      const response = await ServerCall.post(
        `/Recaudacion/MercantilPA/DeleteTarjeta`,
        body,
        user.token
      );
      return response;
  };

  const pagoTDCMercantil = async (input) => {
      var body = new FormData();
      body.append("nombreCliente", input.nombreCliente);
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("fechven", input.fechaVen);
      body.append("monto", input.monto);
      body.append("transaccion", input.transaccion);
      body.append("cvv", input.cvv);
      body.append("canal", "Portal Web");
      body.append("email", input.email);
      body.append("ip", await getIp());
      body.append("cuenta", input.cuenta);
      body.append("idAbonado", input.idAbonado);
      body.append("docIdentidad", input.docIdentidad);
        const response = await ServerCall.post(
        `/Recaudacion/MercantilPA/CreatePaymentTdc`,
        body,
        user.token
      );
  
      return response;
  };

  const pagoTokenMercantil = async (input) => {

      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("token", input.token); // Token de la tarjeta seleccionada
      body.append("monto", input.monto);
      body.append("transaccion", input.transaccion);
      body.append("cvv", input.cvv);
      body.append("canal", "Portal Web");
      body.append("email", input.email);
      body.append("ip", await getIp());
      body.append("cuenta", input.cuenta);
      body.append("idAbonado", input.idAbonado);
      body.append("docIdentidad", input.docIdentidad);
      const response = await ServerCall.post(
        `/Recaudacion/MercantilPA/CreatePaymentToken`,
        body,
        user.token
      );
      return response;

  };

  const mercantilRegistro = async (input) => {
      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("docIdentidad", input.docIdentidad); 
      const response = await ServerCall.post(
        `/Recaudacion/Mercantil/Autenticacion`,
        body,
        user.token
      );
     return response;
  };

  const mercantilPago = async (input) => {
      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("docIdentidad", input.docIdentidad); 
      body.append("tipoCuenta", input.tipoCuenta); 
      body.append("twoFactor", input.otp); 
      body.append("fechaExpiracion", input.fechaExpiracion); 
      body.append("cvv", input.cvv);
      body.append("amount", input.amount);
      body.append("cuenta", input.nroCuenta);
      body.append("invoice", Math.round(Math.random() * 10000000000));
      const response = await ServerCall.post(
        `/Recaudacion/Mercantil/Pago`,
        body,
        user.token
      );
      return response;
  };
  const mercantilPagoTDC = async (input) => {
      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("docIdentidad", input.docIdentidad); 
      body.append("fechaExpiracion", input.fechaExpiracion); 
      body.append("cvv", input.cvv);
      body.append("amount", input.amount);
      body.append("cuenta", input.nroCuenta);
      body.append("invoice", Math.round(Math.random() * 10000000000));
      const response = await ServerCall.post(
        `/Recaudacion/Mercantil/PagoTDC`,
        body,
        user.token
      );
      return response;
  };

  const masterDebitController = async (input) => {
      var body = new FormData();
      body.append("nroTarjeta", input.nroTarjeta);
      body.append("docIdentidad", input.docIdentidad); 
      body.append("fechaExpiracion", input.fechaExpiracion); 
      body.append("cvv", input.cvv);
      body.append("amount", input.amount);
      body.append("cuenta", input.nroCuenta);
      body.append("invoice", Math.round(Math.random() * 10000000000));
      const response = await ServerCall.post(
        `/Recaudacion/Mercantil/PagoTDC`,
        body,
        user.token
      );
      return response;
  };
 
 const notificacionesCorporativo = async (input) => {
    var body = new FormData();
      body.append("tipoNotificacion", input.tipoNotificacion);
      body.append("nombre", input.nombre); 
      body.append("docIdentidad", input.docIdentidad); 
      body.append("email", input.email);
      body.append("ciudad", input.ciudad);
      body.append("nroCuentas", input.nroCuentas);
      body.append("cuentaAbonado", input.cuentaAbonado);
      body.append("tlfContacto", input.tlfContacto);
      body.append("nroFacturas", input.nroFacturas); 
      body.append("tipoCuentaMoneda", input.tipoCuentaMoneda); 
      body.append("bancoReceptor", input.bancoReceptor);
      body.append("nroCuentaReceptor", input.nroCuentaReceptor);
      body.append("fechaPago", input.fechaPago);
      body.append("nroReferencia", input.nroReferencia);
      body.append("montoPago", input.montoPago); 
      body.append("isRetencion", input.isRetencion); 
      body.append("isRetencionIVA", input.isRetencionIVA);
      body.append("montoIVA", input.montoIVA);
      body.append("fileIVA", input.fileIVA);
      body.append("isRetencionISLR", input.isRetencionISLR);
      body.append("montoISLR", input.montoISLR); 
      body.append("fileISLR", input.fileISLR); 
      body.append("isRetencionTimbre", input.isRetencionTimbre);
      body.append("montoTimbreFiscal", input.montoTimbreFiscal);
      body.append("fileTimbreFiscal", input.fileTimbreFiscal);
      body.append("isRetencionMunicipal", input.isRetencionMunicipal);
      body.append("montoCompMunicipal", input.montoCompMunicipal); 
      body.append("fileCompMunicipal", input.fileCompMunicipal); 
   
    const response = await ServerCall.postNetUno(
      `/RCJ/NotificarCorporativo`,
      body

    );
    return response;
};


  return {
    getBancos,
    pagoTokenMercantil,
    afilicacionP2C,
    desAfilicacionP2C,
    pagoBanesco,
    pagoCreditCard,
    getTarjetaMercantil,
    pagoTDCMercantil,
    deleteTarjetaMercantil,
    crearPagoBDV,
    procesarPagoBDV,
    pagoZelle,
    notificacionP2C,
    tokenCreditCard,
    mercantilPago,
    mercantilRegistro,
    mercantilPagoTDC,
    masterDebitController,
    notificacionesCorporativo,
  };
};

export default PagosController;
